
/**
 * First we will load all of this project's JavaScript dependencies which
 * include Vue and Vue Resource. This gives a great starting point for
 * building robust, powerful web applications using Vue and Laravel.
 */

// require('./bootstrap');

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// Vue.component('example', require('./components/Example.vue'));

// const app = new Vue({
//     el: '#app'
// });

$(document).ready(function () {

    // https://github.com/select2/select2/issues/3300
    // IE breaks when using a multiple select with a placeholder
    // Temp Patch Start
    var msie = document.documentMode;
    var disableInputEvents = msie && msie <= 11;
    var options = {};

    if(!disableInputEvents){
        options = {placeholder: "alle"};
    }
    // Temp Patch Finish

    $('.js-select2').select2(options);

});
